import React from 'react';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';

import type { ProfileDefault } from '../../../../types/uncinc_profile/profile';
import ProfileCard from '../Card';
import avatar from '../../../../assets/images/avatar.svg';

interface ProfileProps {
  entity: ImmutableEntity<ProfileDefault>;
}

const ProfileTeaser: React.FC<ProfileProps> = ({ entity }) => {
  const profile = entity.toJS();
  // @ts-expect-error
  const profileUrl = `/${profile.path[0].langcode}${profile.path[0].alias}`;
  const profileFirstName = profile.field_first_name[0].value;
  const profileLastName = profile.field_last_name[0]?.value;
  const fullName = [profileFirstName, profileLastName].join(' ') as unknown as string;
  const profileFunctions = profile.field_functions[0]?.entity.name[0].value;
  const image = profile.field_media_item[0];

  return (
    <ProfileCard
      title={fullName}
      subtitle={profileFunctions}
      image={image ? (
        <DynamicMediaItem
          media={image}
          imageAspectRatio="1_1"
        />
      ) : (
        <img src={avatar} alt={fullName} />
      )}
      link={profileUrl}
      minimal
    />
  );
};

export default ProfileTeaser;

